import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";
import axios from "axios";
var GET_CONTEXTS_URL = "/tracking-contexts";

var getSPEvents = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(contexts) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post(GET_CONTEXTS_URL, {
              contexts: contexts
            })["catch"](function () {
              return {
                data: []
              };
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSPEvents(_x) {
    return _ref.apply(this, arguments);
  };
}();

var emitSnowplowEvent = function emitSnowplowEvent(event) {
  event.forEach(function (snowplowEvent) {
    trackSelfDescribingEvent({
      event: snowplowEvent
    });
  });
};
/**
 * This function will make a call to the backend to retrieve the requested contexts.
 * Use trackSelfDescribingEvent instead if you have all the available data.
 */


export var submitSPEvents = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(contexts) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getSPEvents(contexts);

          case 2:
            response = _context2.sent;

            if (response !== null && response !== void 0 && response.data) {
              emitSnowplowEvent(response.data.flat().filter(Boolean));
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function submitSPEvents(_x2) {
    return _ref2.apply(this, arguments);
  };
}();